var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "max-w-screen-xl mx-auto my-20 px-4 sm:px-6 lg:px-8" },
    [
      _c("div", { staticClass: "sm:flex sm:flex-col sm:align-center" }, [
        _c(
          "div",
          {
            staticClass:
              "relative self-center bg-gray-100 rounded-lg p-0.5 flex sm:mt-8",
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "relative w-1/2 border rounded-md py-2 text-sm leading-5 font-medium text-gray-700 whitespace-no-wrap hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue focus:z-10 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 sm:w-auto sm:px-8",
                class: {
                  "bg-white border-gray-200  shadow-sm":
                    _vm.sharedState.period === "monthly",
                  "border-transparent": _vm.sharedState.period === "yearly",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.sharedState.period = "monthly"
                  },
                },
              },
              [_vm._v("\n                Monthly billing\n            ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "relative w-1/2 border rounded-md py-2 text-sm leading-5 font-medium text-gray-700 whitespace-no-wrap hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue focus:z-10 active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150 sm:w-auto sm:px-8",
                class: {
                  "bg-white border-gray-200  shadow-sm":
                    _vm.sharedState.period === "yearly",
                  "border-transparent": _vm.sharedState.period === "monthly",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.sharedState.period = "yearly"
                  },
                },
              },
              [_vm._v("\n                Yearly billing\n            ")]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-3",
        },
        _vm._l(_vm.plans, function (plan) {
          return _c("pricing-plan", { key: plan.id, attrs: { plan: plan } })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }